module.exports = __webpack_public_path__ + "static/media/6h.f002060b.png";